import * as _ from 'lodash';
function formatDate(date:Date){
    const year = date.getFullYear();
    const month = numberTo2DigitsString(date.getMonth() +1);
    const day = numberTo2DigitsString(date.getDate());
    const hours = numberTo2DigitsString(date.getHours());
    const minutes = numberTo2DigitsString(date.getMinutes());
    const seconds = numberTo2DigitsString(date.getSeconds());
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}

function timestamp(date: Date){
	const year = date.getFullYear();
	const month = numberTo2DigitsString(date.getMonth() +1);
	const day = numberTo2DigitsString(date.getDate());
	const hours = numberTo2DigitsString(date.getHours());
	const minutes = numberTo2DigitsString(date.getMinutes());
	const seconds = numberTo2DigitsString(date.getSeconds());
	return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

function numberTo2DigitsString(number){
    return `${number<10?0:''}${number}`;
}

function isValidDate(d: Date) {
	return !_.isNil(d) && d instanceof Date && !isNaN(d.getTime());
}

function isDate(d){
	return d instanceof Date
}

function truncDate(date: Date): Date{
	const newDate = new Date(date);
	newDate.setHours(0, 0, 0, 0);
	return newDate;
}

function limitTop(date: Date, limit: Date){
	date = date.getTime() > limit.getTime() ? limit: date;
	return date;
}

function limitBot(date: Date, limit: Date){
	date = date.getTime() < limit.getTime() ? limit: date;
	return date;
}

function limitTo(st: Date, et:Date, limitSt: Date, limitEt: Date){
	st = limitBot(st, limitSt); //mínimo es limitSt
	et = limitTop(et, limitEt); //máximo es limitEt => et no puede ser mayor que limitEt
	return {st, et};
}

export {formatDate, isValidDate, isDate, timestamp, truncDate, limitTo};
